import clsx from 'clsx';
import { Modal } from '../_custom';
import styles from './Configurable.module.scss';

interface ModalActionButton {
    label?: string;
    onClick?: () => void;
    style?: React.CSSProperties;
    disabled?: boolean;
}

interface ConfigurableModalProps {
    isOpen: boolean;
    onClose: () => void;
    heading: string;
    message: string;
    deleteFunction?: () => void;
    primaryButton?: ModalActionButton;
    secondaryButton?: ModalActionButton;
    variant?: 'default' | 'comfortable';
}

const ConfigurableModal = ({
    isOpen,
    onClose,
    heading,
    message,
    deleteFunction,
    primaryButton = {
        label: 'Delete',
        onClick: deleteFunction,
        style: {},
        disabled: false,
    },
    secondaryButton = {
        label: 'Cancel',
        onClick: onClose,
        style: {},
    },
    variant = 'default',
}: ConfigurableModalProps) => {
    return (
        <Modal open={isOpen} onClose={onClose} size="flexible">
            <div className={clsx(styles.DeleteContainer, variant === 'comfortable' && styles.Comfortable)}>
                <div className={styles.MessageContainer}>
                    <div className={styles.Heading}>{heading}</div>
                    <div className={styles.Message}>{message}</div>
                </div>
                <div className={styles.ButtonContainer}>
                    <button className={styles.CancelButton} onClick={secondaryButton.onClick} style={secondaryButton.style}>
                        {secondaryButton.label}
                    </button>
                    <button
                        className={styles.DeleteButton}
                        onClick={primaryButton.onClick}
                        style={primaryButton.style}
                        disabled={primaryButton.disabled}
                    >
                        {primaryButton.label}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConfigurableModal;
